import dayjs, { Dayjs } from "dayjs";

export interface DatePeriod {
  month: number;
  year: number;
}

export const shouldDisableMonthGenerator =
  (startPeriod?: DatePeriod | null, endPeriod?: DatePeriod | null) =>
  (date: Dayjs) => {
    if (!startPeriod || !endPeriod) {
      const currentDate = dayjs();
      return date.month() !== currentDate.month();
    }

    const dateYear = date.year();
    const dateMonth = date.month();

    if (dateYear < startPeriod.year || dateYear > endPeriod.year) {
      return true;
    }

    if (dateYear === startPeriod.year && dateMonth < startPeriod.month) {
      return true;
    }

    if (dateYear === endPeriod.year && dateMonth > endPeriod.month) {
      return true;
    }

    return false;
  };

export const shouldDisableYearGenerator =
  (startPeriod?: DatePeriod | null, endPeriod?: DatePeriod | null) =>
  (year: Dayjs) => {
    if (!startPeriod || !endPeriod) {
      return year.year() !== dayjs().year();
    }
    return year.year() < startPeriod.year || year.year() > endPeriod.year;
  };

export const getReferenceDateFromStartPeriod = (
  startPeriod?: DatePeriod | null
): Dayjs | undefined => {
  if (!startPeriod) {
    return undefined;
  }

  return dayjs()
    .set("year", startPeriod.year)
    .set("month", startPeriod.month)
    .startOf("month");
};

export const getFirstEnabledMonth = (
  year: number,
  newValue: Dayjs,
  shouldDisableMonth: ((month: any) => boolean) | undefined
): number | null => {
  if (!shouldDisableMonth) return 0;

  for (let month = 0; month < 12; month += 1) {
    const testDate = newValue?.set("month", month).set("year", year);
    if (!shouldDisableMonth(testDate)) {
      return month;
    }
  }

  return null;
};

export const isDateValid = (
  newValue: Dayjs | null,
  shouldDisableMonth: ((month: any) => boolean) | undefined,
  shouldDisableYear: ((year: any) => boolean) | undefined
): boolean => {
  if (!newValue) return false;

  const monthDisabled = shouldDisableMonth?.(newValue) ?? false;
  const yearDisabled = shouldDisableYear?.(newValue) ?? false;

  return !monthDisabled && !yearDisabled;
};
